export default "__VITE_PUBLIC_ASSET__3af67e68__"